export default __webpack_public_path__ + "static/media/graphicDesign.8545365e.jpg";